/**
 * 首页猜你喜欢
 */
<template>
    <div class="homeGuessWhatYouLike">
        <!-- 猜你喜欢标题 -->
        <!-- <Headlines ref="headLinesInstance" :Text="Text" :showTitle="showTitle"></Headlines> -->
        <!-- <img
            class="guess-img"
            src="//m.360buyimg.com/jrqb/jfs/t27640/157/429042520/10345/9ffa7680/5badf5caN0c01e768.png"
        > -->
        <ExclusiveTitle :ExclusiveTitle="`猜你喜欢`" />
        <!-- 猜你喜欢类别 -->
        <!-- <NavigaterBarScroll class="home-NavigaterBarScroll nav-bar-scroll" ref="navBarScroll" :data="categorys" :currentIndex="navigaterBarScrollCurrentIndex" :currentX="guessLikecurrentX" @onItemClick="onItemClick" @onScroll="onNavBarScroll" @onScrollEnd="onNavBarScrollEnd" /> -->
        <!-- 猜你喜欢商品 -->
        <div
            class="homeGuessWhatYouLike-busCard"
            :style="{ minHeight: navHideByMinY + 'px' }"
        >
            <BusCardList
                ref="busCardListInstance"
                :data="dataList"
                @onMoreElementInView="onMoreElementInView"
                :hasMoreData="hasMoreData"
                :eventId="'MInterestFree_LikePro'"
                :clstagName='clstagName'
                :channel="'like'"
            />
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import request from '@/util/request';
import Headlines from '@/buscomponents/Headlines.vue';
import NavigaterBarScroll from '@/buscomponents/NavigaterBarScroll.vue';
import BusCardList from '@/buscomponents/BusCardList.vue';
// import Slider from '@/components/Slider.vue';
import { getStaticConfig } from '@/util/common';

import { debounce } from 'lodash';
import ExclusiveTitle from '@/buscomponents/ExclusiveTitle.vue';
import { getQuery } from '@/util/url';
export default {
    name: 'HomeGuessWhatYouLike',
    components: {
        Headlines,
        NavigaterBarScroll,
        BusCardList,
        ExclusiveTitle
        // Slider
    },
    props: {
        navigaterBarScrollCurrentIndex: {
            type: Number,
            default: 0
        },
        guessLikecurrentX: {
            type: Number,
            default: 0
        },
        categorys: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            navHideByMinY: window.innerHeight,
            // 猜你喜欢标题
            Text: 'LIKE',
            showTitle: '猜你喜欢',
            // 猜你喜欢的列表
            dataList: [],
            currentCategory: '0',
            lastId: '0',
            hasMoreData: true,
            homePageCategorys: '',
            clstagName: '8530052_1227_index_like'
        };
    },
    mounted() {
        try {
            this.homePageCategorys = getStaticConfig('homePageCategorys');
        } catch (error) {
            console.log(error);
        }
        this.debounceReqGuessWhatYouLike = debounce(this.reqGuessWhatYouLike, 600, { leading: true, trailing: false });
    },
    methods: {
        onItemClick(data) {
            this.$emit('onItemClick', data);
        },
        onNavBarScroll(e) {
            this.$emit('onNavBarScroll', e);
        },
        onNavBarScrollEnd(e) {
            this.$emit('onNavBarScrollEnd', e);
        },
        firstLoadGuessLikeByCategory() {
            let value;
            // this.dataList = [];
            try {
                // value = this.categorys && this.categorys.length && this.categorys[0] && this.categorys[0].value;
                value = this.homePageCategorys;
            } catch (e) {
                console.log(e);
            }
            this.loadGuessLikeByCategory({ value });
        },
        // 加载猜你喜欢
        loadGuessLikeByCategory(category, isScroll) {
            const { value } = category;
            if (this.currentCategory !== value) {
                this.lastId = '0';
                this.currentCategory = value;
                this.dataList = [];
                // 猜你喜欢
                this.reqGuessWhatYouLike(isScroll);
            }
        },
        // ajax请求猜你喜欢
        reqGuessWhatYouLike(isScroll) {
            if (String(this.currentCategory) === '0') {
                return;
            }
            let me = this;
            let qs = getQuery();
            me.coverSku = qs.sku || '';
            if ($.device.jdjr && qs.skuId && qs.from == 'jdjr') {
                me.coverSku = qs.skuId;
                delete qs.sku;
                delete qs.otherSku;
            }
            if ($.device.jdjr && qs.otherSku && qs.from == 'jdjr') {
                me.coverSku = qs.otherSku;
                delete qs.skuId;
                delete qs.sku;
            }
            request.guessWhatYouLike({
                // 参数
                data: {
                    category: this.currentCategory,
                    lastId: this.lastId,
                    coverSku: me.coverSku > 0 ? me.coverSku : ''
                },
                // 成功
                success: ({ recommendGoodsList, isEnd, lastId }) => {
                    this.$loading.hide();
                    if (recommendGoodsList && recommendGoodsList.length && !isEnd) {
                        this.dataList = this.dataList.concat(recommendGoodsList);
                        this.lastId = recommendGoodsList[recommendGoodsList.length - 1].skuId;
                        this.hasMoreData = true;
                        this.$emit('onBetterScrollRefresh', { isScroll });
                    } else {
                        if (recommendGoodsList.length == 0 && !isEnd && lastId) {
                            this.lastId = lastId;
                            this.hasMoreData = true;
                            this.reqGuessWhatYouLike(isScroll);
                        } else {
                            this.hasMoreData = false;
                        }
                    }
                },
                error: () => {}
            });
        },
        onMoreElementInView() {
            console.log('onMoreElementInView');
            this.debounceReqGuessWhatYouLike();
        }
    },
    destroyed() {
        this.$refs = null;
        this.debounceReqGuessWhatYouLike = null;
        this._self = null;
    }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.homeGuessWhatYouLike {
    background: #ffffff;
    padding: $rem60 $rem32 0 $rem32;
}
.homeGuessWhatYouLike-busCard {
    background: #fff;
    overflow: hidden;
    // padding-top: $rem32;
}
.guess-img {
    width: 100%;
    background: #ffffff;
}
.home-NavigaterBarScroll {
    background: #fff;
    // padding-bottom: $rem32;
}
</style>
